import { PERMISSIONS } from '@gpl/constants';

export type TenantKey = 'W' | 'P' | 'Y';

export interface TenantDef {
  key: TenantKey;
  nameKey: string;
  codeKey: string;
}

export const TENANTS: readonly TenantDef[] = [
  { key: 'W', nameKey: 'tenant.witty_name', codeKey: 'tenant.witty_code' },
  { key: 'P', nameKey: 'tenant.psp_name', codeKey: 'tenant.psp_code' },
  { key: 'Y', nameKey: 'tenant.ypc_name', codeKey: 'tenant.ypc_code' },
] as const;

export interface NavItemDef {
  id: string;
  path: string;
  icon: string;
  labelKey: string;
  /** i18n key for unread/pending count label, when we later wire live counts */
  badgeSource?: 'approvals' | 'messages';
  /** If present, nav item is gated; shows lock icon when user lacks this permission */
  permission?: string;
}

export interface NavSectionDef {
  id: 'main' | 'quick';
  labelKey: string;
  items: readonly NavItemDef[];
}

export const NAV_SECTIONS: readonly NavSectionDef[] = [
  {
    id: 'main',
    labelKey: 'nav.section_main',
    items: [
      { id: 'home', path: '/', icon: 'home', labelKey: 'nav.home' },
      {
        id: 'messages',
        path: '/messages',
        icon: 'forum',
        labelKey: 'nav.messages',
        badgeSource: 'messages',
      },
      {
        id: 'approvals',
        path: '/approvals',
        icon: 'task_alt',
        labelKey: 'nav.approvals',
        badgeSource: 'approvals',
        permission: PERMISSIONS.APPROVAL.VIEW,
      },
      {
        id: 'reports',
        path: '/reports',
        icon: 'monitoring',
        labelKey: 'nav.reports',
        permission: 'mes:reports:view_basic',
      },
      { id: 'profile', path: '/profile', icon: 'person', labelKey: 'nav.profile' },
    ],
  },
  {
    id: 'quick',
    labelKey: 'nav.section_quick',
    items: [
      { id: 'requests', path: '/requests', icon: 'edit_note', labelKey: 'nav.requests' },
      {
        id: 'attendance',
        path: '/attendance',
        icon: 'fingerprint',
        labelKey: 'nav.attendance',
      },
      {
        id: 'fa-inventory',
        path: '/fa-inventory',
        icon: 'qr_code_scanner',
        labelKey: 'nav.fa_inventory',
      },
    ],
  },
] as const;
